import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Topic with Parameter Value NOT in List",
  order: 130,
};
